module.exports = fox => {
	'use strict';

	fox.registerWidget('MCP_Login_Wizard_LoginForm', {
		configure() {
			this.registerOptions('', {
                '--widgets.snManager': 1,
                redirectUrl: 'models',
                // 'widgets.authApi': {
                //     method: 'Affiliate.authorizer.auth',
                // }
			});

			return this.callParent('configure', arguments);
        },

        running() {
            this.rwom1('#authApi').setOption('method', 'Affiliate.authorizer.securedAuth');
            
            this.callParent('running', arguments);

            this.notices = fox.wom.selectFirst('~.Layout_Promo_Auth ~#throughNotifications');
        },

        formSubmitError(err) {
			//this.showErrorMessage(err.answer.reason);
            //this.togglePreloader(false);
            
            this.notices.pushNotification({
                noticeTemplate: 'new_notice',
                noticeType: 'error',
                noticeMessage: err.answer.reason,
                noticeAlias: 'loginError',
                delayClose: 3000
            });

            this.togglePreloader(false);
		},

        getTextMessage(alias) {
            let msg = '';

            switch (alias) {
                case 'emailNotValid':
                    msg = 'Email is not valid';
                    break;
                case 'fieldNotEmpty':
                    msg = 'Fields shouldn\'t be empty';
                    break;
            }

            return msg;
        },

        showErrorMessage(msg, fieldName) {
            //console.log(msg, fieldName)
            var $elm = $(this.dom1(`[name="${fieldName}"]`)).parent().find('.error-container');

            $elm.text(msg);

        },

        login(response) {
			const redirectUrl = this.getOption('redirectUrl');

			if (redirectUrl) {
				fox.Navigator.update({0: redirectUrl}, true);
			}

			window.location.reload(true);
		},

	}, 'Login_Wizard_LoginForm');
};



// WEBPACK FOOTER //
// ./components/login-wizard/widget/login-form.es.js